import axios from '@/plugins/axios'

export function getCoupon(params = {}) {
  return axios.get('coupon', {
    params,
  })
}
export function getCouponUserBags(params = {}) {
  return axios.get('coupon_user_bags', {
    params,
  })
}

export function getAdvertisementSelectData() {
  return axios.get('advertisements/advertisementSelectData')
}

export function editCoupon(id) {
  return axios.get(`coupon/${id}/edit`)
}

export function storeCoupon(data) {
  return axios.post('coupon', data)
}
export function giveCouponToUser(data) {
  return axios.post('coupon/giveCouponToUser', data)
}

export function updateCoupon(id, data) {
  return axios.put(`coupon/${id}`, data)
}
